import React from 'react';
import { BannersCarouselItemsListProps } from '../types';
import { BannersCarouselItem } from './banners-carousel-item';
import { Banner } from 'api/placements-api';

export const BannersCarouselItemsList: React.FC<BannersCarouselItemsListProps> = props => {
  const { content, onImpressionContentClick, onImpressionContentView, itemClassName, targetBlank } = props;

  const handleClick = (id: string, banner: Banner, index: number) => {
    if (onImpressionContentClick) {
      onImpressionContentClick({
        contentId: id,
        bannerPosition: index + 1,
        link: banner.targetUrl,
      });
    }
  };

  const handleView = (id: string, banner: Banner, index: number) => {
    if (onImpressionContentView) {
      onImpressionContentView({
        contentId: id,
        bannerPosition: index + 1,
        link: banner.targetUrl,
      });
    }
  };

  return (
    <>
      {content.map(({ id, banner, ord }, index) => (
        <BannersCarouselItem
          key={id}
          className={itemClassName}
          onClick={() => handleClick(id, banner, index)}
          onView={() => handleView(id, banner, index)}
          {...{ banner, ord, targetBlank }}
        />
      ))}
    </>
  );
};
